module.exports = __webpack_public_path__ + "static/media/3.b9a5ef42.jpeg";